import each from './each';

export default function values(obj) {
  const arr = [];
  each(obj, (value) => {
    arr.push(value);
  });
  return arr;
}